// extracted by mini-css-extract-plugin
export default {"AddGamesFormContainer":"AddGamesForm_AddGamesFormContainer__C76Zw","FormInformation":"AddGamesForm_FormInformation__PxKbe","LockIcon":"AddGamesForm_LockIcon__yNqjs"};